<template>
    <kiosk-layout>
        <template v-slot:subtitle>
            <a :href="termsListHref" class="no-underline! text-sky-600! text-base font-normal">
                <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                Terms
            </a>
        </template>
        <template v-slot:title>
            <span class="inline-flex items-center gap-3">
                {{ props.term.title }}
                <term-status-badge :status="props.term.status" size="sm" />
            </span>
        </template>
        <template v-slot:sidebar>
            <page-sidebar :links="sidebarLinks"></page-sidebar>
        </template>

        <slot></slot>
    </kiosk-layout>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PageSidebar from '~/components/general/PageSidebar.vue';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import type { Term } from '~/services/adminTermsClient.types';
import TermStatusBadge from './TermStatusBadge.vue';

const props = defineProps<{
    teamId: number;
    term: Term;
}>();

const termsListHref = computed(() => `/kiosk/teams/${props.teamId}/terms`);

const sidebarLinks = computed(() => [
    { href: `/kiosk/teams/${props.teamId}/terms/${props.term.id}`, label: 'Details' },
    { href: `/kiosk/teams/${props.teamId}/terms/${props.term.id}/acceptances`, label: 'Acceptances' },
    { href: `/kiosk/teams/${props.teamId}/terms/${props.term.id}/status-logs`, label: 'Status Log' },
]);
</script>
